import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("0 0 20 20", "Info", /*#__PURE__*/_jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm7.5 0h-1V9h2v4h1v1h-2v-4Zm1.438-3.003a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0Z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconInfo";
export default Icon;